import React, { useEffect, useState } from 'react'
import Modal from '@components/common/modal/Modal'
import { Button, Input, LinkText } from '@components/common/form'
import { GuestOrderConfig } from '@types'

type Props = {
  guestOrderConfig: GuestOrderConfig
  onSave: (config: GuestOrderConfig) => void
  closeModal: () => void
}

const defaultConfig = {
  maxOrdersPerGuest: 0,
  allowedEmailDomains: [],
}

const getInitialValues = (
  config: GuestOrderConfig,
): {
  maxOrders: string
  allowedDomains: string
} => {
  const maxOrders = config.maxOrdersPerGuest
    ? config.maxOrdersPerGuest.toString()
    : ''
  const allowedDomains = config.allowedEmailDomains.join(', ')

  return {
    maxOrders,
    allowedDomains,
  }
}

const EditClientSettingsGuestOrderConfigModal: React.FC<Props> = (props) => {
  const { onSave, closeModal } = props

  const guestOrderConfig = props.guestOrderConfig || defaultConfig

  const initialValues = getInitialValues(guestOrderConfig)

  const [maxOrders, setMaxOrders] = useState(initialValues.maxOrders)
  const [allowedDomains, setAllowedDomains] = useState(
    initialValues.allowedDomains,
  )

  useEffect(() => {
    const values = getInitialValues(guestOrderConfig)
    setMaxOrders(values.maxOrders)
    setAllowedDomains(values.allowedDomains)
  }, [guestOrderConfig])

  const onChangeMaxOrders = (value: string) => {
    setMaxOrders(value)
  }

  const onChangeAllowedDomains = (value: string) => {
    setAllowedDomains(value)
  }

  const handleSave = () => {
    const max = maxOrders.trim()
    const maxOrdersValue = maxOrders === '' ? 0 : parseInt(max)

    const domainsValue = allowedDomains
      .split(',')
      .map((item) => item.trim())
      .filter(Boolean)

    const config = {
      maxOrdersPerGuest: maxOrdersValue,
      allowedEmailDomains: domainsValue,
    }

    onSave(config)
    closeModal()
  }

  const renderContent = () => {
    return (
      <div className="edit-client-settings-guest-order-config-modal">
        <div>
          <div>
            <Input
              label="Max orders per guest"
              value={maxOrders}
              type="number"
              onChange={(e) => onChangeMaxOrders(e.target.value)}
            />
          </div>

          <div>
            <Input
              label="Allowed email domains"
              value={allowedDomains}
              onChange={(e) => onChangeAllowedDomains(e.target.value)}
              marginBottom="0px"
            />
            <div className="domains-hint">
              If adding multiple domains, use a comma to separate them, e.g.
              <div className="example-domains">
                tryhungry.com, naturebox.com
              </div>
            </div>
          </div>
        </div>

        <div className="buttons-container">
          <LinkText label="Cancel" onClick={closeModal} color="#b30303" />
          <Button label="Save" onClick={handleSave} />
        </div>
      </div>
    )
  }

  return (
    <Modal
      title={'Edit guest order configuration'}
      hideModal={closeModal}
      color="#001940"
      maxWidth="500px"
      width="500px"
      minHeight="600px"
      maxHeight="80vh"
    >
      {renderContent()}
    </Modal>
  )
}

export default EditClientSettingsGuestOrderConfigModal
